import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  // Aquí defines tu validación real:
  // - si usas token en localStorage (no ideal): !!localStorage.getItem("token")
  // - si usas cookie httpOnly: usa un estado de auth (context) o una llamada /me
  const isAuth = !!localStorage.getItem("token");

  return isAuth ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;